import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** A calm heads-up when the phone drops offline. Cached screens stay readable. */
export function OfflineBanner() {
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (online) return null;
  return (
    <div role="status" className="fixed inset-x-0 top-[var(--tfwp-demo-bar,0px)] z-50 pt-safe">
      <div className="mx-auto mt-2 flex w-fit items-center gap-2 rounded-full bg-hero px-4 py-2 text-footnote font-semibold text-hero-text shadow-lift animate-fade-in">
        <WifiOff className="h-4 w-4" aria-hidden />
        You're offline. Showing what you last saw.
      </div>
    </div>
  );
}
